import { User, Device } from "../models";
import { APIVersion, AuthenticatedFileRequest, AuthenticatedRequest, HTTPMethod, Session, BasicRequest } from "../requests/request";
import { DeviceData } from "..";
import { DataSourceType, DataSource } from '../models/datasource';

export class API {

    /**
     * Signs up a new user
     * @returns {Promise<Device>} The Promise contains an APIError if rejected
     * Error Types:
     * 400 InvalidParametersError
     * 403 ResourceAlreadyExists: Email already existing
     * 500 InternalServerError
     */
    public static signUp(email: string, password: string, full_name: string, device: DeviceData): Promise<Device> {
        let apiRequest = new BasicRequest<Device>('/users', HTTPMethod.POST, APIVersion.v1_0, {}, {
            registration_fullname: full_name,
            registration_data: {
                email: email,
                password: password,
            },
            device: device,
        });

        return apiRequest.send(Device).then((response) => {
            return <Device>response.data;
        });
    }


    /**
     * Fetches the user
     * @returns {Promise<User>} The Promise contains an APIError if rejected
     */
    public static getMe(): Promise<User> {
        let apiRequest = new AuthenticatedRequest<User>('/users/me', HTTPMethod.GET, APIVersion.v1_0);

        return apiRequest.send(User).then((response) => {
            return <User>response.data;
        });
    }

    public static updateMe(full_name: string, account?: { name: string }): Promise<User> {
        let apiRequest = new AuthenticatedRequest<User>('/users/me', HTTPMethod.PUT, APIVersion.v1_0, {}, {
            full_name, account
        });

        return apiRequest.send(User).then((response) => {
            return <User>response.data;
        });
    }

    /**
     * Updated the user's password
     * @returns {Promise<User>} The Promise contains an APIError if rejected
     */
    public static changePassword(from: string, to: string): Promise<void> {
        let apiRequest = new AuthenticatedRequest<void>('/users/me/change_password', HTTPMethod.POST, APIVersion.v1_0, undefined, {
            password: to,
            old_password: from
        });

        return apiRequest.send().then((response) => {
            return <void>response.data;
        });
    }

    public static addAddress(address: NewAddress): Promise<Address> {
        let apiRequest = new AuthenticatedRequest<User>('/users/me/address', HTTPMethod.POST, APIVersion.v1_0, undefined, address);

        return apiRequest.send().then((response) => {
            return response.data;
        });
    }

    public static getAddresses(): Promise<Array<Address>> {
        let apiRequest = new AuthenticatedRequest<User>('/users/me/address', HTTPMethod.GET, APIVersion.v1_0);

        return apiRequest.send().then((response) => {
            return response.data;
        });
    }

    public static addDatasource(code: string, type: DataSourceType): Promise<DataSource> {
        let apiRequest = new AuthenticatedRequest<DataSource>('/users/me/datasources', HTTPMethod.POST, APIVersion.v1_0, undefined, {
            access_code: code,
            type
        });

        return apiRequest.send(DataSource).then((response) => {
            return response.data;
        });
    }

    public static getDatasources(): Promise<Array<DataSource>> {
        let apiRequest = new AuthenticatedRequest<DataSource>('/users/me/datasources', HTTPMethod.GET, APIVersion.v1_0);

        return apiRequest.send(DataSource).then((response) => {
            return response.data;
        });
    }

    public static deleteDatasource(source: DataSource): Promise<void> {
        let apiRequest = new AuthenticatedRequest<void>('/users/me/datasources/' + source.id, HTTPMethod.DELETE, APIVersion.v1_0);

        return apiRequest.send().then((response) => {
            return void 0;
        });
    }

    public static getTableauToken(): Promise<string> {
        let apiRequest = new AuthenticatedRequest<void>('/users/me/tableau_token', HTTPMethod.GET, APIVersion.v1_0);

        return apiRequest.send().then((response) => {
            return response.data.token;
        });
    }
}

export interface Datasource {
    type: 'google' | 'facebook'
}

export interface NewAddress {
    address_line1: string;
    address_line2?: string;
    city: string;
    zip: string;
    state?: string;
    country: string;
    first_name: string;
    last_name: string;
}
export interface Address extends NewAddress {
    id: string,
    created_at: string;
}


// WEBPACK FOOTER //
// ./src/api/endpoints/user.ts